import PropTypes from 'prop-types';
import {parsePhoneNumber} from "libphonenumber-js";
import getWorkshop from "./getWorkshop";

const phoneNumberLabel = (phoneNumber, format = null) => {
  try {
    const phoneNumberParsed = parsePhoneNumber(phoneNumber.number, phoneNumber.countryCode)

    if(!phoneNumberParsed.isValid()){
      return phoneNumber.number
    }

    if(format){
      switch (format) {
        case 'uri': return phoneNumberParsed.getURI()
      }
    }

    if(getWorkshop().countryCode === phoneNumber.countryCode){
      return phoneNumberParsed.formatNational()
    }else{
      return phoneNumberParsed.formatInternational()
    }
  } catch (e){
    return phoneNumber.number
  }
};

phoneNumberLabel.PropTypes = {
  phoneNumber: PropTypes.shape({
    countryCode: PropTypes.string,
    number: PropTypes.string,
  }),
}

export default phoneNumberLabel;